import axios from 'axios';

// Configure axios instance
const BASE = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/';
const API_URL = process.env.REACT_APP_API_URL || `${BASE.replace(/\/$/, '')}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for adding auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
